import { ContinueButtonTypes, type QuestionType } from '@core/blocks/edu-flow/components/Page/types';
import { type MonarchEditableAsset } from '@core/context/types';
import { type DeepPartial } from '@core/ts/types';

export type SecurityBoostEditableAsset = MonarchEditableAsset<{
  popupHeader?: string;
  popupContent?: string;
  popupCtaLabel?: string;
  ctaLabel?: string;
}>;

const securityBoost = (
  question: QuestionType,
  {
    questionHeading,
    questionSubHeading,
    questionStepId,
    questionStepName,
    sidePanelContentValue,
    sidePanelContentHeading,
    securityDisclaimer,
    popupHeader,
    popupContent,
    popupCtaLabel,
    ctaLabel,
  }: SecurityBoostEditableAsset
): QuestionType => {
  const { fields = [], additionalContent: [customInfoPanel] = [] } = question;

  const [customConsent] = fields;

  const populatedQuestion: DeepPartial<QuestionType> = {
    heading: questionHeading,
    postSubheading: questionSubHeading,
    stepId: questionStepId,
    stepName: questionStepName,
    continueButton: {
      type: ContinueButtonTypes.POPUP_BUTTON,
      ctaLabel,
      popupCtaLabel,
      popupExitButtonName: 'security-boost-exit',
      popupContent,
      heading: popupHeader,
    },
    conditionalContinue: [
      {
        name: 'phoneAndEmailExist',
        operator: 'AND',
        action: 'SHOW',
        rules: [
          {
            field: 'phone',
            type: 'EXISTS',
          },
          {
            field: 'email',
            type: 'EXISTS',
          },
        ],
      },
    ],
    fields: [
      {
        type: 'phone',
        name: 'phone',
        required: true,
        label: 'Phone Number',
        autocompleteValue: 'tel',
      },
      {
        type: 'text',
        format: 'email',
        name: 'email',
        required: true,
        label: 'Email',
        autocompleteValue: 'email',
      },
      customConsent ?? {
        name: 'emailConsent',
        default: true,
        type: 'checkbox',
        label:
          "I would like to sign up to receive email updates from BestColleges. See our <a href='/privacy-policy/' target='_BLANK'><span style=\"text-decoration: underline;\">Privacy Policy</span></a>.",
        preampAsset: 'voyager-email-consent-box',
        monarchTest: 'voyagerEmailConsentBox',
      },
      {
        type: 'securityDisclaimer',
        name: 'securityDisclaimer',
        content: securityDisclaimer,
      },
    ],
    additionalContent: [
      customInfoPanel ?? {
        name: 'infoPanel',
        type: 'infoPanel',
        heading: sidePanelContentHeading,
        headingIcon: '#',
        content: sidePanelContentValue,
      },
    ],
  };

  return populatedQuestion as QuestionType;
};

export default securityBoost;
